<template>
  <loading
    color="#6618CE"
    v-model:active="loading"
    :can-cancel="true"
    :on-cancel="onCancel"
    :is-full-page="true"
  />
  <Header />
  <!-- ======================= Top Breadcrubms ======================== -->
  <div class="gray py-3">
    <div class="container">
      <div class="row">
        <div class="colxl-12 col-lg-12 col-md-12">
          <!-- <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item"><a href="#">Library</a></li>
              <li class="breadcrumb-item active" aria-current="page">Data</li>
            </ol>
          </nav> -->
        </div>
      </div>
    </div>
  </div>
  <!-- ======================= Top Breadcrubms ======================== -->

  <!-- ======================= Product Detail ======================== -->
  <section class="middle">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <!-- Main detail image  -->
          <ImageDetailImage :image="mainImage" />
          <!-- Main detail image -->
          <div
            class="align-items-center justify-content-left ml-1 row d-flex mt-2 mb-4"
          >
            <div
              v-for="item in product.images"
              :key="item"
              style="cursor: pointer"
            >
              <div @click="setMainImage(item)" class="prod-image-small">
                <img
                  class="p-1"
                  :style="`border: ${
                    item == mainImage ? '1px solid #000' : 'none'
                  }`"
                  :src="item"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
          <div class="prd_details">
            <div class="prt_01 mb-1">
              <span class="text-purple bg-light-purple rounded py-1">{{
                product.category && product.category.name
              }}</span>
            </div>
            <div class="prt_02 mb-3">
              <h2 class="ft-bold mb-1">{{ product.name }}</h2>
              <div class="text-left">
                <div
                  v-if="product.deliveryTime"
                  class="star-rating align-items-center d-flex justify-content-left mb-1 p-2"
                >
                  <!-- <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i>
                  <i class="fas fa-star filled"></i> -->
                  <i class="fas fa-truck"></i>
                  <span class="small"
                    >Temps de livraison pour c'est produit
                    <span class="ft-bold mr-2"
                      >{{ product.deliveryTime }} jours
                    </span></span
                  >
                  <span
                    v-if="product.origin"
                    class="text-success bg-light-success rounded px-2 py-1"
                    >{{ product.origin }}</span
                  >
                </div>
                <div class="elis_rty">
                  <span class="ft-medium text-muted line-through fs-md mr-2">{{
                    `${product.fakePrice ? "$" + product.fakePrice : ""}`
                  }}</span
                  ><span class="ft-bold theme-cl fs-lg mr-2">{{
                    "$" + product.price
                  }}</span
                  ><span
                    v-if="product.stock"
                    class="ft-regular text-light bg-success py-1 px-2 fs-sm"
                    >En stocke</span
                  >
                  <span
                    v-if="!product.stock"
                    class="ft-regular text-light bg-danger py-1 px-2 fs-sm"
                    >Indisponible</span
                  >
                </div>
              </div>
            </div>

            <div class="prt_03 mb-4">
              <p>
                {{ product.description }}
              </p>
            </div>

            <!-- <div class="prt_04 mb-2">
              <p class="d-flex align-items-center mb-0 text-dark ft-medium">
                Color:
              </p>
              <div class="text-left">
                <div class="form-check form-option form-check-inline mb-1">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="color8"
                    id="white8"
                  />
                  <label class="form-option-label rounded-circle" for="white8"
                    ><span class="form-option-color rounded-circle blc7"></span
                  ></label>
                </div>
                <div class="form-check form-option form-check-inline mb-1">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="color8"
                    id="blue8"
                  />
                  <label class="form-option-label rounded-circle" for="blue8"
                    ><span class="form-option-color rounded-circle blc2"></span
                  ></label>
                </div>
                <div class="form-check form-option form-check-inline mb-1">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="color8"
                    id="yellow8"
                  />
                  <label class="form-option-label rounded-circle" for="yellow8"
                    ><span class="form-option-color rounded-circle blc5"></span
                  ></label>
                </div>
                <div class="form-check form-option form-check-inline mb-1">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="color8"
                    id="pink8"
                  />
                  <label class="form-option-label rounded-circle" for="pink8"
                    ><span class="form-option-color rounded-circle blc3"></span
                  ></label>
                </div>
                <div class="form-check form-option form-check-inline mb-1">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="color8"
                    id="red"
                  />
                  <label class="form-option-label rounded-circle" for="red"
                    ><span class="form-option-color rounded-circle blc4"></span
                  ></label>
                </div>
                <div class="form-check form-option form-check-inline mb-1">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="color8"
                    id="green"
                  />
                  <label class="form-option-label rounded-circle" for="green"
                    ><span class="form-option-color rounded-circle blc6"></span
                  ></label>
                </div>
              </div>
            </div> -->

            <div class="prt_04 mb-4">
              <p class="d-flex align-items-center mb-0 text-dark ft-medium">
                Taille disponible:
              </p>
              <div class="text-left pb-0 pt-2">
                <div
                  v-for="item in product.size"
                  :key="item"
                  class="form-check size-option form-option form-check-inline mb-2"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    name="size"
                    :id="item"
                    checked=""
                  />
                  <label class="form-option-label" for="28">{{ item }}</label>
                </div>
              </div>
            </div>

            <div class="prt_05 mb-4">
              <div class="form-row mb-7">
                <!-- <div class="col-12 col-lg-auto">
                  <select class="mb-2 custom-select">
                    <option value="1" selected="">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                  </select>
                </div> -->
                <div class="col-6 col-lg">
                  <!-- Submit -->
                  <!-- <button
                    type="submit"
                    class="btn btn-block text-light custom-height bg-green mb-2"
                  >
                  https://perishopp.com/dashboard/gallery
                   
                  </button> -->
                  <a
                    :href="`https://wa.me/${243995303733}?text=https://perishopp.com${
                      this.$route.fullPath
                    }`"
                    target="_blank"
                    class="btn btn-block text-light custom-height bg-green mb-2"
                    :description="product.description"
                  >
                    <i class="lni lni-whatsapp mr-2"></i>Acheter sur whatsapp
                  </a>
                </div>
                <div class="col-6 col-lg">
                  <!-- Submit -->
                  <!-- <button
                    type="submit"
                    class="btn btn-block text-light custom-height bg-green mb-2"
                  >
                  https://perishopp.com/dashboard/gallery
                   
                  </button> -->
                  <a
                    href="https://telegram.me/Henock_Emporio"
                    target="_blank"
                    class="btn btn-block bg-blue text-light custom-height bg-green mb-2"
                    :description="product.description"
                  >
                    <i class="lni lni-telegram mr-2"></i>Acheter sur telegram
                  </a>
                </div>
                <div class="col-12 col-lg-auto">
                  <!-- Wishlist -->
                  <!-- <button
                    class="btn custom-height btn-default btn-block mb-2 text-dark"
                    data-toggle="button"
                  >
                    <i class="lni lni-heart mr-2"></i>Wishlist
                  </button> -->
                </div>
              </div>
            </div>

            <!-- <div class="prt_06">
              <p class="mb-0 d-flex align-items-center">
                <span class="mr-4">Share:</span>
                <a
                  class="d-inline-flex align-items-center justify-content-center p-3 gray circle fs-sm text-muted mr-2"
                  href="#!"
                >
                  <i class="fab fa-twitter position-absolute"></i>
                </a>
                <a
                  class="d-inline-flex align-items-center justify-content-center p-3 gray circle fs-sm text-muted mr-2"
                  href="#!"
                >
                  <i class="fab fa-facebook-f position-absolute"></i>
                </a>
                <a
                  class="d-inline-flex align-items-center justify-content-center p-3 gray circle fs-sm text-muted"
                  href="#!"
                >
                  <i class="fab fa-pinterest-p position-absolute"></i>
                </a>
              </p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ======================= Product Detail End ======================== -->

  <!-- ======================= Product Description ======================= -->
  <!-- <section class="middle">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-xl-11 col-lg-12 col-md-12 col-sm-12">
          <ul
            class="nav nav-tabs b-0 d-flex align-items-center justify-content-center simple_tab_links mb-4"
            id="myTab"
            role="tablist"
          >
            <li class="nav-item" role="presentation">
              <a
                class="nav-link active"
                id="description-tab"
                href="#description"
                data-toggle="tab"
                role="tab"
                aria-controls="description"
                aria-selected="true"
                >Description</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link"
                href="#information"
                id="information-tab"
                data-toggle="tab"
                role="tab"
                aria-controls="information"
                aria-selected="false"
                >Additional information</a
              >
            </li>
            <li class="nav-item" role="presentation">
              <a
                class="nav-link"
                href="#reviews"
                id="reviews-tab"
                data-toggle="tab"
                role="tab"
                aria-controls="reviews"
                aria-selected="false"
                >Reviews</a
              >
            </li>
          </ul> -->

  <!-- <div class="tab-content" id="myTabContent"> -->
  <!-- Description Content -->
  <!-- <div
              class="tab-pane fade show active"
              id="description"
              role="tabpanel"
              aria-labelledby="description-tab"
            >
              <div class="description_info">
                <p class="p-0 mb-2">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur.
                </p>
                <p class="p-0">
                  At vero eos et accusamus et iusto odio dignissimos ducimus qui
                  blanditiis praesentium voluptatum deleniti atque corrupti quos
                  dolores et quas molestias excepturi sint occaecati cupiditate
                  non provident, similique sunt in culpa qui officia deserunt
                  mollitia animi, id est laborum et dolorum fuga.
                </p>
              </div>
            </div> -->

  <!-- Additional Content -->
  <!-- <div
              class="tab-pane fade"
              id="information"
              role="tabpanel"
              aria-labelledby="information-tab"
            >
              <div class="additionals">
                <table class="table">
                  <tbody>
                    <tr>
                      <th class="ft-medium text-dark">ID</th>
                      <td>#1253458</td>
                    </tr>
                    <tr>
                      <th class="ft-medium text-dark">SKU</th>
                      <td>KUM125896</td>
                    </tr>
                    <tr>
                      <th class="ft-medium text-dark">Color</th>
                      <td>Sky Blue</td>
                    </tr>
                    <tr>
                      <th class="ft-medium text-dark">Size</th>
                      <td>Xl, 42</td>
                    </tr>
                    <tr>
                      <th class="ft-medium text-dark">Weight</th>
                      <td>450 Gr</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> -->

  <!-- Reviews Content -->
  <!-- <div
              class="tab-pane fade"
              id="reviews"
              role="tabpanel"
              aria-labelledby="reviews-tab"
            >
              <div class="reviews_info"> -->
  <!-- <div class="single_rev d-flex align-items-start br-bottom py-3">
                  <div class="single_rev_thumb">
                    <img
                      src="assets/img/team-1.jpg"
                      class="img-fluid circle"
                      width="90"
                      alt=""
                    />
                  </div>
                  <div class="single_rev_caption d-flex align-items-start pl-3">
                    <div class="single_capt_left">
                      <h5 class="mb-0 fs-md ft-medium lh-1">Daniel Rajdesh</h5>
                      <span class="small">30 jul 2021</span>
                      <p>
                        At vero eos et accusamus et iusto odio dignissimos
                        ducimus qui blanditiis praesentium voluptatum deleniti
                        atque corrupti quos dolores et quas molestias excepturi
                        sint occaecati cupiditate non provident, similique sunt
                        in culpa qui officia deserunt mollitia animi, id est
                        laborum
                      </p>
                    </div>
                    <div class="single_capt_right">
                      <div
                        class="star-rating align-items-center d-flex justify-content-left mb-1 p-0"
                      >
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                      </div>
                    </div>
                  </div>
                </div> -->

  <!-- Single Review -->
  <!-- <div class="single_rev d-flex align-items-start br-bottom py-3">
                  <div class="single_rev_thumb">
                    <img
                      src="assets/img/team-2.jpg"
                      class="img-fluid circle"
                      width="90"
                      alt=""
                    />
                  </div>
                  <div class="single_rev_caption d-flex align-items-start pl-3">
                    <div class="single_capt_left">
                      <h5 class="mb-0 fs-md ft-medium lh-1">Seema Gupta</h5>
                      <span class="small">30 Aug 2021</span>
                      <p>
                        At vero eos et accusamus et iusto odio dignissimos
                        ducimus qui blanditiis praesentium voluptatum deleniti
                        atque corrupti quos dolores et quas molestias excepturi
                        sint occaecati cupiditate non provident, similique sunt
                        in culpa qui officia deserunt mollitia animi, id est
                        laborum
                      </p>
                    </div>
                    <div class="single_capt_right">
                      <div
                        class="star-rating align-items-center d-flex justify-content-left mb-1 p-0"
                      >
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                      </div>
                    </div>
                  </div>
                </div> -->

  <!-- Single Review -->
  <!-- <div class="single_rev d-flex align-items-start br-bottom py-3">
                  <div class="single_rev_thumb">
                    <img
                      src="assets/img/team-3.jpg"
                      class="img-fluid circle"
                      width="90"
                      alt=""
                    />
                  </div>
                  <div class="single_rev_caption d-flex align-items-start pl-3">
                    <div class="single_capt_left">
                      <h5 class="mb-0 fs-md ft-medium lh-1">Mark Jugermi</h5>
                      <span class="small">10 Oct 2021</span>
                      <p>
                        At vero eos et accusamus et iusto odio dignissimos
                        ducimus qui blanditiis praesentium voluptatum deleniti
                        atque corrupti quos dolores et quas molestias excepturi
                        sint occaecati cupiditate non provident, similique sunt
                        in culpa qui officia deserunt mollitia animi, id est
                        laborum
                      </p>
                    </div>
                    <div class="single_capt_right">
                      <div
                        class="star-rating align-items-center d-flex justify-content-left mb-1 p-0"
                      >
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                      </div>
                    </div>
                  </div>
                </div> -->

  <!-- Single Review -->
  <!-- <div class="single_rev d-flex align-items-start py-3">
                  <div class="single_rev_thumb">
                    <img
                      src="assets/img/team-4.jpg"
                      class="img-fluid circle"
                      width="90"
                      alt=""
                    />
                  </div>
                  <div class="single_rev_caption d-flex align-items-start pl-3">
                    <div class="single_capt_left">
                      <h5 class="mb-0 fs-md ft-medium lh-1">Meena Rajpoot</h5>
                      <span class="small">17 Dec 2021</span>
                      <p>
                        At vero eos et accusamus et iusto odio dignissimos
                        ducimus qui blanditiis praesentium voluptatum deleniti
                        atque corrupti quos dolores et quas molestias excepturi
                        sint occaecati cupiditate non provident, similique sunt
                        in culpa qui officia deserunt mollitia animi, id est
                        laborum
                      </p>
                    </div>
                    <div class="single_capt_right">
                      <div
                        class="star-rating align-items-center d-flex justify-content-left mb-1 p-0"
                      >
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                      </div>
                    </div>
                  </div>
                </div> -->
  <!-- </div> -->

  <!-- <div class="reviews_rate">
                <form class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <h4>Submit Rating</h4>
                  </div>

                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div
                      class="revie_stars d-flex align-items-center justify-content-between px-2 py-2 gray rounded mb-2 mt-1"
                    >
                      <div class="srt_013">
                        <div class="submit-rating">
                          <input
                            id="star-5"
                            type="radio"
                            name="rating"
                            value="star-5"
                          />
                          <label for="star-5" title="5 stars">
                            <i class="active fa fa-star" aria-hidden="true"></i>
                          </label>
                          <input
                            id="star-4"
                            type="radio"
                            name="rating"
                            value="star-4"
                          />
                          <label for="star-4" title="4 stars">
                            <i class="active fa fa-star" aria-hidden="true"></i>
                          </label>
                          <input
                            id="star-3"
                            type="radio"
                            name="rating"
                            value="star-3"
                          />
                          <label for="star-3" title="3 stars">
                            <i class="active fa fa-star" aria-hidden="true"></i>
                          </label>
                          <input
                            id="star-2"
                            type="radio"
                            name="rating"
                            value="star-2"
                          />
                          <label for="star-2" title="2 stars">
                            <i class="active fa fa-star" aria-hidden="true"></i>
                          </label>
                          <input
                            id="star-1"
                            type="radio"
                            name="rating"
                            value="star-1"
                          />
                          <label for="star-1" title="1 star">
                            <i class="active fa fa-star" aria-hidden="true"></i>
                          </label>
                        </div>
                      </div>

                      <div class="srt_014">
                        <h6 class="mb-0">4 Star</h6>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label class="medium text-dark ft-medium"
                        >Full Name</label
                      >
                      <input type="text" class="form-control" />
                    </div>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                      <label class="medium text-dark ft-medium"
                        >Email Address</label
                      >
                      <input type="email" class="form-control" />
                    </div>
                  </div>

                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div class="form-group">
                      <label class="medium text-dark ft-medium"
                        >Description</label
                      >
                      <textarea class="form-control"></textarea>
                    </div>
                  </div>

                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div class="form-group m-0">
                      <a class="btn btn-white stretched-link hover-black"
                        >Submit Review <i class="lni lni-arrow-right"></i
                      ></a>
                    </div>
                  </div>
                </form>
              </div> -->
  <!-- </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->
  <!-- ======================= Product Description End ==================== -->

  <!-- ======================= Similar Products Start ============================ -->
  <section class="middle pt-0">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <div class="sec_title position-relative text-center">
            <h2 class="off_title">Similar Products</h2>
            <h3 class="ft-bold pt-3">Produits similaires</h3>
          </div>
        </div>
      </div>

      <div class="row">
        <single-product
          v-for="item in similarProducts"
          :key="item.id"
          :data="item"
        />
      </div>
    </div>
  </section>
  <!-- ======================= Similar Products Start ============================ -->

  <!-- ======================= Customer Features ======================== -->
  <!-- <section class="px-0 py-3 br-top">
    <div class="container">
      <div class="row">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <div class="d-flex align-items-center justify-content-start py-2">
            <div class="d_ico">
              <i class="fas fa-shopping-basket"></i>
            </div>
            <div class="d_capt">
              <h5 class="mb-0">Free Shipping</h5>
              <span class="text-muted">Capped at $10 per order</span>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <div class="d-flex align-items-center justify-content-start py-2">
            <div class="d_ico">
              <i class="far fa-credit-card"></i>
            </div>
            <div class="d_capt">
              <h5 class="mb-0">Secure Payments</h5>
              <span class="text-muted">Up to 6 months installments</span>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <div class="d-flex align-items-center justify-content-start py-2">
            <div class="d_ico">
              <i class="fas fa-shield-alt"></i>
            </div>
            <div class="d_capt">
              <h5 class="mb-0">15-Days Returns</h5>
              <span class="text-muted">Shop with fully confidence</span>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
          <div class="d-flex align-items-center justify-content-start py-2">
            <div class="d_ico">
              <i class="fas fa-headphones-alt"></i>
            </div>
            <div class="d_capt">
              <h5 class="mb-0">24x7 Fully Support</h5>
              <span class="text-muted">Get friendly support</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->
  <!-- ======================= Customer Features ======================== -->
  <ShipDetailVue />
  <Footer />
  <SearchModal />

  <a id="back2Top" class="top-scroll" title="Back to top" href="#"
    ><i class="ti-arrow-up"></i
  ></a>
</template>

<script>
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import SingleProduct from "../../components/product/singleProduct.vue";
import ShipDetailVue from "@/components/product/ShipDetail.vue";
import ImageDetailImage from "../../components/product/mainDetailImage.vue";
import SearchModal from "../../components/searchModal.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  getProductDetail,
  getProductByCategory,
} from "../../services/product.services";
export default {
  components: {
    Header,
    Footer,
    SingleProduct,
    ShipDetailVue,
    SearchModal,
    ImageDetailImage,
    Loading,
  },
  data() {
    return {
      loading: false,
      mainImage: null,
      product: {},
      similarProducts: [],
      fullPath: window.location.href,
    };
  },
  methods: {
    setMainImage(src) {
      this.mainImage = src;
    },
    productDetail() {
      this.loading = true;
      getProductDetail(this.$route.params.id).then((res) => {
        if (res.state) {
          this.product = res.data;
          this.mainImage = res.data.images[0];
          console.log(res.data);
          getProductByCategory(res.data.category.id).then((resp) => {
            if (resp.state) {
              this.similarProducts = resp.data;
              this.loading = false;
              console.log(this.similarProducts);
            } else {
              this.similarProducts = [];
              this.loading = false;
            }
          });
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
  },
  mounted() {
    this.productDetail();
  },
};
</script>

<style></style>
